module.exports = __webpack_public_path__ + "img/Alipay.67b030e0.png";